import React, { Component } from 'react'

export default class FileDownloader extends Component {
  constructor() {
    super()
    this.state = {
      mounted: false,
    }
  }
  download = () => {
    //console.log(this.props.fileName, this.props.href)
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(this.props.blob, this.props.fileName)
      if (this.props.downloadComplete) this.props.downloadComplete()
    } else {
      this.setState(
        {
          mounted: true,
        },
        () => {
          this.link.click()
          this.setState({
            mounted: false,
          })
        }
      )
    }
  }
  render() {
    const { fileName = 'downloaded', href, downloadComplete } = this.props
    return this.state.mounted ? (
      <a
        href={href}
        ref={(link) => {
          this.link = link
        }}
        style={{
          visibility: 'hidden',
          opacity: 0,
          width: 1,
          height: 1,
          position: 'fixed',
          right: -1,
          bottom: -1,
        }}
        onClick={(e) => {
          e.stopPropagation()
          if (downloadComplete) downloadComplete()
        }}
        download={fileName}
      ></a>
    ) : null
  }
}
